export default {
  overview: {
    title: "Categories Overview",
    archive_title: "Archived categories",
    subtitle: "List of all categories.",
    search: {
      placeholder: "eg. name or description",
    },
    actions: {
      create_new: "Create New Category",
    },
    table: {
      headers: {
        name: "Name",
        description: "Description",
        createdAt: "Created at",
      },
      empty: {
        description: "Not set",
      },
    },
  },
  create: {
    title: "Create category",
    subtitle: "Create a new category.",
  },
  detail: {
    title: "Category Details",
    tabs: {
      general: "General",
      activity: "Activity",
    },
    actions: {
      update: "Save",
    },
    form: {
      name: "Name",
      description: "Description",
      description_hint: "Optional description of the category",
    },
  },
  component: {
    tagField: {
      create: 'Create category "{value}"',
      empty: "Type a name to create a category.",
      no_match: "No category found.",
    },
    catalogue: {
      title: "Manage categories",
      subtitle: "The categories of the whole company. Click a category to edit its name and description.",
      empty: "No categories yet.",
      add: "Add category",
      search: "Search by name or description",
      no_match: "No category matches the search.",
      count: "{count} category | {count} categories",
      name: "Name",
      description: "Description (optional)",
      no_description: "No description",
      name_taken: "A category with this name already exists.",
      rename_hint: "The change applies everywhere the category is used.",
      remove_title: "Remove category?",
      remove_text:
        'The category "{name}" disappears from the picker. If a report already uses it, it stays there and moves to the archive. Otherwise it is deleted.',
    },
  },
}
